import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight, CheckCircle } from "react-feather";
import { LAUNCH_EVENT } from "../../../data/launchEventConfig";

export default function HeroLaunchStrip() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.35, duration: 0.6 }}
      className="launch-hero-strip-completed rounded-2xl p-4 sm:p-5 mb-8"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-start gap-3 min-w-0">
          <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#22c55e]/20 flex items-center justify-center text-[#86efac]">
            <CheckCircle size={20} strokeWidth={2.5} />
          </div>
          <div className="min-w-0">
            <p className="text-[#86efac] text-[10px] sm:text-xs font-bold uppercase tracking-[0.18em]">
              Launch Completed · 2026
            </p>
            <p className="text-white font-bold text-base sm:text-lg mt-0.5 truncate">
              {LAUNCH_EVENT.date} · {LAUNCH_EVENT.venue}, Tirupathi
            </p>
            <p className="text-white/50 text-xs sm:text-sm mt-1 flex items-center gap-1">
              <MapPin size={12} className="flex-shrink-0" />
              <span className="truncate">{LAUNCH_EVENT.address}</span>
            </p>
          </div>
        </div>

        <Link
          to="/launch-event"
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-white/8 border border-white/15 hover:bg-white/12 hover:border-[#F5C044]/40 transition-all flex-shrink-0"
        >
          View launch recap
          <ArrowRight size={16} />
        </Link>
      </div>
    </motion.div>
  );
}
